import { Helmet } from 'react-helmet-async'

const Home = () => {
  const { __ } = useTranslator()

  return (
    <>
      <Helmet>
        <title>Home</title>
      </Helmet>
      <h1>{__('Home page')}</h1>
    </>
  )
}

export default Home
